<!--
   添加标签弹窗
-->
<template>
	<!-- 弹窗管理 -->
	<el-dialog :visible.sync="isVisible"
			   class="primary-dialog"
			   :width="width"
			   :title="title"
			   :close-on-click-modal="false"
			   @closed="handleClosed">
		<!-- 添加资料弹窗 -->
		<template v-if="module === 'tag'">
			<!-- 当前选择标签 -->
			<el-row>
				<el-col :span="4"
						class="text-right row-label"><span>当前选择标签</span></el-col>
				<el-col :span="20"
						class="tags-container">
					<el-tag v-for="(item, index) in dialogData.selectedTags"
							:key="'selectTag' + index"
							effect="dark"
							size="small"
							class="mr5 mb5"
							closable
							@close="onTagRemove(item)">{{ item.sname }}</el-tag>
				</el-col>
			</el-row>

			<!-- 新增时的 输入框 -->
			<el-row class="mt5">
				<el-col :span="20">
					<el-input v-model="newTagName"
							  placeholder="输入新的标签"
							  :maxlength="15"
							  show-word-limit></el-input>
				</el-col>
				<el-col :span="4"
						class="text-right pdl10">
					<el-button type="primary"
							   class="w100"
							   @click="addNewTag">保存</el-button>
				</el-col>
			</el-row>

			<!-- 全部标签 -->
			<div class="mt5 tags-all-container">
				<el-tag v-for="(item, index) in dialogData.allTags"
						:key="'allTags' + index"
						:effect="item.isChoose === 1 ? 'dark' : 'plain'"
						size="small"
						@click="onTagSelected(item)">{{ item.sname }}</el-tag>
			</div>
		</template>

		<!-- footer 组件 -->
		<div slot="footer"
			 class="text-center">
			<el-button size="small"
					   @click="handleClosed">取 消</el-button>
			<el-button type="primary"
					   size="small"
					   :loading="btnLoading"
					   @click="doTagsSave">确 认</el-button>
		</div>
	</el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import * as Api from '@/api/modules/home'
import { stat } from 'fs'

export default {
	name: 'AddLabelDialog',
	props: {
		isShowDialog: {
			type: Boolean,
			default: false,
		},
		dialogData: {
			type: Object,
			default: '',
		},
		curRowId: {
			type: String,
			default: '',
		},
		curRowName: {
			type: String,
			default: '',
		},
		tagFor: {
			type: String,
			default: '1056001',
		},
	},
	data() {
		return {
			isVisible: false,
			width: '200',
			title: '添加标签',
			module: 'tag',
			btnLoading: false,
			originalTags: [], // 初始选择的标签（做最后对比）
			selectedTags: [], // 当前选择标签
			allTags: [], // 所有标签（不再显示说明）
			newTagName: '', // 输入的标签名称
		}
	},
	created() {},
	watch: {
		isShowDialog(newValue, oldValue) {
			this.isVisible = newValue
		},
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),
	},
	methods: {
		// 保存输入的标签
		addNewTag() {
			// 去除空格
			let value = this.newTagName.replace(/\s+/, '')
			if (value && value !== '') {
				// 再判断标签 是否已存在
				let _item = this.dialogData.allTags.find(
					(x) => x.sname === value
				)
				if (_item) {
					switch (_item.isChoose) {
						case 1:
							this.$message.info('该标签已选择！')
							break
						default:
							_item.isChoose = 1
							this.dialogData.selectedTags.push(_item)
					}
				} else {
					let params = {
						id: '',
						tagId: '',
						sname: value,
						type: '0',
						isChoose: 1,
					}
					// this.dialogData.allTags.push(params);
					this.dialogData.selectedTags.push(params)
				}

				this.newTagName = ''
			} else {
				this.$message.warning('请输入要保存的标签！')
			}
		},

		// 标签选择
		onTagSelected(item) {
			// 选中状态
			item.isChoose = item.isChoose === 1 ? 0 : 1

			// 选中标签数组
			if (item.isChoose === 1) {
				this.dialogData.selectedTags.push(item)
			} else {
				let index = this.dialogData.selectedTags.findIndex(
					(x) => x.tagId === item.tagId
				)

				if (index > -1) {
					this.dialogData.selectedTags.splice(index, 1)
				}
			}
		},

		// 选中标签删除
		onTagRemove(item) {
			// 如果不是 新增的标签
			if (item.tagId !== '') {
				let _index = this.dialogData.allTags.findIndex(
					(x) => x.tagId === item.tagId
				)
				if (_index > -1) {
					this.dialogData.allTags[_index].isChoose = 0
				}
			}

			// 选中数组移除
			this.dialogData.selectedTags.splice(
				this.dialogData.selectedTags.indexOf(item),
				1
			)
		},

		// 标签弹窗保存
		doTagsSave() {
			this.btnLoading = true
			let params = {
				objectId: this.curRowId,
				objectName: this.curRowName,
				applys: this.tagFor,
				createUserid: this.userInfo.id,
				createUser: this.userInfo.sname,
				addTags: this.dialogData.selectedTags,
				deleteTags: [],
			}
			// 新增、删除标签数组处理
			this.dialogData.originalTags.map((x) => {
				let _item = this.dialogData.selectedTags.find(
					(y) => y.id === x.id
				)
				if (!_item) {
					params.deleteTags.push(x)
				}
			})
			params.addTags = this.dialogData.selectedTags.filter(
				(x) => !x.id || x.id === ''
			)

			if (params.addTags.length === 0 && params.deleteTags.length === 0) {
				this.$message.warning('请操作后保存！')
				setTimeout(() => {
					this.btnLoading = false
				}, 2000)
				return
			}
			// 执行保存接口
			Api.saveObjectTags(params)
				.then((res) => {
					setTimeout(() => {
						this.btnLoading = false
						this.handleClosed(true)
					}, 2000)
				})
				.catch((err) => {
					setTimeout(() => {
						this.btnLoading = false
					}, 2000)
				})
		},

		// 弹窗关闭
		handleClosed(needRefresh) {
			this.$emit('close-dialogStatus', needRefresh)
		},
	},
}
</script>

<style scoped lang="less">
.text-right {
	text-align: left;
}
.mb5 {
	margin-bottom: 5px;
}
.btn {
	padding: 0 50px !important;
}
.tags-all-container {
	.el-tag--small {
		height: 32px;
		line-height: 32px;
		margin-right: 8px;
		margin-bottom: 18px;
	}
}
</style>
